module.exports = __webpack_public_path__ + "media/promo/promo/images/chief-3-6463cc3278bd3e1e03fe2f6eb4369320.png";